import { Injectable, inject } from '@angular/core';
import { PartnerService } from './partner.service';
import { IPartnerService } from '../../interfaces/partner-services';
import { CommunityConfigService } from '../util/community-config.service';
import { Partner } from '../../interfaces/partner';

@Injectable({
  providedIn: 'root',
})
export class ArgoService extends PartnerService implements IPartnerService {
  private argoUrl = inject(CommunityConfigService).getExternalApi(Partner.ARGO);

  override getServiceUrl(): string {
    return this.argoUrl;
  }
}
